import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0148788a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PReference_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { style: {"font-size":"12px"} }
const _hoisted_4 = { class: "PReference_BtnBlock" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "loading"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "取置明細ダウンロード", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "loading"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_11 = { class: "PReference_Table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "th_narrow sticky_th sticky_th_line1" }, "－", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "th_narrow sticky_th sticky_th_line1" }, "－", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "th_small sticky_th sticky_th_line1" }, "現在在庫ST", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "3",
  class: "th_wide sticky_th sticky_th_line1"
}, " 商品備考 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "3",
  class: "th_middle sticky_th sticky_th_line1"
}, " シリーズ ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "sticky_th sticky_th_line2"
}, [
  /*#__PURE__*/_createTextVNode(" VAN強制ST"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（表示期限） ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky_th sticky_th_line2 Text_Left" }, "製品種別", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky_th sticky_th_line3" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode("―")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky_th sticky_th_line3" }, "最新刷数", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky_th sticky_th_line3" }, "断裁", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky_th sticky_th_line3 Text_Left" }, "著者", -1))
const _hoisted_26 = {
  key: 0,
  class: "PReference_Table_Body"
}
const _hoisted_27 = { class: "sticky_td sticky_column1 Text_Left delimiter" }
const _hoisted_28 = { class: "sticky_td sticky_column2 Text_Left delimiter" }
const _hoisted_29 = {
  rowspan: "3",
  class: "sticky_td sticky_column3"
}
const _hoisted_30 = {
  rowspan: "3",
  class: "Text_Right sticky_td sticky_column4"
}
const _hoisted_31 = { class: "Text_Right sticky_td sticky_column5 delimiter" }
const _hoisted_32 = { class: "Text_Right sticky_td sticky_column6 delimiter highlight" }
const _hoisted_33 = {
  rowspan: "3",
  class: "Text_Right",
  style: {"border-left":"none !important"}
}
const _hoisted_34 = { class: "Text_Right delimiter" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "Text_Right delimiter" }
const _hoisted_38 = { class: "Text_Right delimiter" }
const _hoisted_39 = { class: "Text_Right delimiter" }
const _hoisted_40 = { class: "Text_Right delimiter" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "Text_Right delimiter" }, "－", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "Text_Right delimiter" }, "－", -1))
const _hoisted_43 = { class: "Text_Right delimiter" }
const _hoisted_44 = { class: "delimiter" }
const _hoisted_45 = { class: "delimiter" }
const _hoisted_46 = { class: "Text_Right delimiter" }
const _hoisted_47 = { class: "Text_Left delimiter" }
const _hoisted_48 = {
  rowspan: "3",
  class: "Text_Left"
}
const _hoisted_49 = { class: "PReference_Table_Flex" }
const _hoisted_50 = { class: "PReference_Table_Bikou_Text" }
const _hoisted_51 = { class: "PReference_TextHL" }
const _hoisted_52 = {
  rowspan: "3",
  class: "Text_Left"
}
const _hoisted_53 = { class: "sticky_td sticky_column1 Text_Left delimiter" }
const _hoisted_54 = {
  rowspan: "2",
  class: "sticky_td sticky_column2 Text_Left"
}
const _hoisted_55 = { class: "Text_Right sticky_td sticky_column5 delimiter" }
const _hoisted_56 = { class: "Text_Right sticky_td sticky_column6 delimiter" }
const _hoisted_57 = { class: "Text_Right delimiter" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "Text_Right delimiter" }
const _hoisted_61 = { class: "Text_Right delimiter" }
const _hoisted_62 = { class: "Text_Right delimiter" }
const _hoisted_63 = { class: "Text_Right delimiter" }
const _hoisted_64 = { class: "Text_Right delimiter" }
const _hoisted_65 = { class: "Text_Right delimiter" }
const _hoisted_66 = {
  rowspan: "2",
  class: "Text_Right PReference_Table_Bikou vn_st"
}
const _hoisted_67 = { class: "PReference_Table_Flex" }
const _hoisted_68 = { class: "PReference_Table_Bikou_Text" }
const _hoisted_69 = {
  key: 0,
  class: "PReference_TextHL"
}
const _hoisted_70 = {
  key: 1,
  class: "PReference_TextHL"
}
const _hoisted_71 = {
  key: 2,
  class: "PReference_TextHL"
}
const _hoisted_72 = { class: "delimiter Text_Right" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "delimiter Text_Right" }
const _hoisted_76 = { class: "Text_Right delimiter" }
const _hoisted_77 = { class: "Text_Left delimiter" }
const _hoisted_78 = { class: "sticky_td sticky_column1 Text_Left" }
const _hoisted_79 = { class: "Text_Right sticky_td sticky_column5" }
const _hoisted_80 = { class: "Text_Right sticky_td sticky_column6" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { key: 1 }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "Text_Right" }, "－", -1))
const _hoisted_84 = { class: "Text_Right" }
const _hoisted_85 = { class: "Text_Right" }
const _hoisted_86 = { class: "Text_Right" }
const _hoisted_87 = { class: "Text_Right" }
const _hoisted_88 = { class: "Text_Right" }
const _hoisted_89 = { class: "Text_Right" }
const _hoisted_90 = { class: "Text_Right" }
const _hoisted_91 = {
  rowspan: "2",
  class: "Text_Red"
}
const _hoisted_92 = { class: "no_last Text_Right" }
const _hoisted_93 = { class: "Text_Left" }
const _hoisted_94 = {
  key: 0,
  class: "ResultMessageNull"
}

import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import axios from "axios";
import { Notyf } from "notyf";
// import ModalOrderSearchMemo from "../components/modal/ModalOrderSearchMemo.vue";
// import ModalOrderSearchVan from "../components/modal/ModalOrderSearchVan.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { ZaikoData } from "../types/zaiko";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductReference',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const store = useStore();
const router = useRouter();

const userInfo = store.getters["login/getUserData"];

// axiosのグローバル設定（トークンの書き換え方法がわからないので未設定）
// const axios = inject<any>("$axios");

//ぱんくずヘッダー
const currentPathList = [{ name: "在庫照会" }];

const props = __props;


// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);

// テーブル表示項目----------------------------------------------
let searchAreaToggle: boolean = true;
let search_result = ref<ZaikoData[]>([]);
let zaikoUpdatedAt = ref("");

const formatJuhanDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (targetDate < today) {
      return null;
    } else {
      const year = targetDate.getFullYear();
      const month = targetDate.getMonth() + 1;
      const day = targetDate.getDate();
      return year + "/" + month + "/" + day;
    }
  } else {
    return null;
  }
};

// 日付のフォーマットを変更する
const formatDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();

    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};
//検索ヘッダ関連----------------------------------------------
let isActive_KaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);

const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "PReference_TableContainer_Short";
  } else {
    //その他
    return "PReference_TableContainer_Long";
  }
};

const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isSorting.value = false;
  getZaikoData();
};

// // モーダル関連----------------------------------------------
// interface selectedProductType {
//   bikou: string;
//   bikou_date_to: string;
//   kyouseiST: string;
//   van_date_to: string;
//   van_date_from: string;
//   van_date_mukigen: boolean;
// }
// let selectedProduct = reactive<selectedProductType>({
//   bikou: "",
//   bikou_date_to: "",
//   kyouseiST: "",
//   van_date_to: "",
//   van_date_from: "",
//   van_date_mukigen: false,
// });
// //備考
// let modalVisible_memo = ref<boolean>(false);
// const updateBikou = (bikouVal: string, date_toVal: string) => {
//   selectedProduct.bikou = bikouVal;
//   selectedProduct.bikou_date_to = date_toVal;
// };
// //van強制ST
// let modalVisible_van = ref<boolean>(false);
// const updateStatus = (
//   statusVal: string,
//   dateFrom: string,
//   dateTo: string,
//   mukigenCheck: boolean
// ) => {
//   selectedProduct.kyouseiST = statusVal;
//   selectedProduct.van_date_from = dateFrom;
//   selectedProduct.van_date_to = dateTo;
//   selectedProduct.van_date_mukigen = mukigenCheck;
//   console.log(selectedProduct);
// };
// const showModal = (ModalName: string, product: any): void => {
//   selectedProduct = product;
//   if (ModalName === "ModalOrderSearchMemo") {
//     modalVisible_memo.value = true;
//   } else if (ModalName === "ModalOrderSearchVan") {
//     modalVisible_van.value = true;
//   }
// };
// const closeModal = (): void => {
//   if (modalVisible_memo.value) {
//     modalVisible_memo.value = false;
//   } else if (modalVisible_van.value) {
//     modalVisible_van.value = false;
//   }
// };

// 在庫データ関連 --------------------------------------------------------
const getZaikoData = async () => {
  search_result.value.splice(0);
  if (isSorting.value === true) {
    await store.dispatch("search/sortZaiko", {
      sortItem: sortInfo.value.sortItem,
      isKoujun: sortInfo.value.isKoujun,
    });
  } else {
    await store.dispatch("search/searchZaiko");
  }
  const res = store.getters["search/getZaikoData"];
  res.syosiList.forEach((syosi: ZaikoData) => {
    search_result.value.push(syosi);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;
  zaikoUpdatedAt.value = res.zaikoUpdatedAt.replace("-", "/");
  getTotalPage();
};
getZaikoData();

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getZaikoData();
};

//参照タブ
// const openDetailTab = (resultId: number): void => {
//   let resolvedRoute = router.resolve({
//     name: "ProductReferenceDetail",
//     params: { id: resultId },
//   });
//   window.open(
//     resolvedRoute.href,
//     "_blank",
//     "width=900,height=380,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
//     (window.screen.width - 1000) / 2 +
//     ",top=" +
//     (window.screen.height - 650) / 2
//   );
// };

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;

  getZaikoData();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};
//ダウンロード------------------------------------------------
// 通常ダウンロード
let isLoading = ref(false);
const getCsvData = async () => {
  isLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getSearchState"];
  try {
    isLoading.value = true;
    const searchParams = `fromDate=${detailState.fromDate}&toDate=${
      detailState.toDate
    }&syubetu=${detailState.syubetu}&category=${
      detailState.category
    }&zaikoStatus=${detailState.zaikoStatus}&freeword=${simpleState}&page=${
      store.getters["search/getPageNumber"]
    }&numberOfDisplay=&order=${
      isSorting.value ? sortInfo.value.sortItem : ""
    }&sort=${isSorting.value ? sortInfo.value.isKoujun : ""}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/zaiko-download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    if (res.data === "") {
      isLoading.value = false;
      notyf.error("ダウンロードするデータがありません");
    } else {
      downloadFile(res);
    }
  } catch (error) {
    isLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFile = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `在庫照会.xlsx`;
  link.click();
  isLoading.value = false;
};

// 取置明細ダウンロード
let isToriokiLoading = ref(false);
const getToriokiCsvData = async () => {
  isToriokiLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getSearchState"];
  try {
    isToriokiLoading.value = true;
    const searchParams = `freeword=${simpleState}&fromDate=${
      detailState.fromDate
    }&toDate=${detailState.toDate}&syubetu=${detailState.syubetu}&category=${
      detailState.category
    }&zaikoStatus=${detailState.zaikoStatus}&hanmotoCd=${
      userInfo.hanmotoCd
    }&page=${store.getters["search/getPageNumber"]}&numberOfDisplay=&order=${
      isSorting.value ? sortInfo.value.sortItem : ""
    }&sort=${isSorting.value ? sortInfo.value.isKoujun : ""}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/torioki-download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    if (res.data === "") {
      isToriokiLoading.value = false;
      notyf.error("ダウンロードするデータがありません");
    } else {
      downloadToriokiFile(res);
    }
  } catch (error) {
    isToriokiLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadToriokiFile = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  // 日付生成
  const targetDate = new Date();
  const year = targetDate.getFullYear().toString();
  const month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
  const day = targetDate.getDate().toString().padStart(2, "0");
  const hours = targetDate.getHours().toString().padStart(2, "0");
  const minutes = targetDate.getMinutes().toString().padStart(2, "0");
  const downloadDate = year + month + day;
  const downloadTime = hours + minutes;

  link.download = `取置明細_${downloadDate}_${downloadTime}.xlsx`;
  link.click();
  isToriokiLoading.value = false;
};

// 他---------------------------------------------
// 取置がクリックされた時に別タブを開く
const openToriokiDetail = async (janCd: string): Promise<void> => {
  let resolvedRoute = router.resolve({
    name: "ToriokiDetail",
    params: { janCd: janCd },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1200,height=300,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};
// 受注保留がクリックされた時に受注保留解除画面に遷移する
const openOrderHold = async (syosiCd: string) => {
  router.push({ path: "/orderHold", query: { syosiCd: syosiCd } });
};
// 品切保留がクリックされた時に品切保留画面に遷移する
const openOrderOutOfStock = async (syosiCd: string) => {
  router.push({ path: "/orderOutOfStock", query: { syosiCd: syosiCd } });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["PReference", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_KaniFlg: _unref(isActive_KaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActive_KaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, _unref(search_result).length]
        ]),
        _createElementVNode("div", _hoisted_3, " 在庫データ取込日時： " + _toDisplayString(_unref(zaikoUpdatedAt)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["PReference_BtnGray", { ShippingHistory_BtnDisabled: _unref(isToriokiLoading) }]),
          download: "sample1.txt",
          onClick: getToriokiCsvData,
          disabled: _unref(isToriokiLoading)
        }, [
          (!_unref(isToriokiLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isToriokiLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
            : _createCommentVNode("", true),
          _hoisted_7
        ], 10, _hoisted_5),
        _createElementVNode("button", {
          class: _normalizeClass(["PReference_BtnGray", { ShippingHistory_BtnDisabled: _unref(isLoading) }]),
          download: "sample.txt",
          onClick: getCsvData,
          disabled: _unref(isLoading)
        }, [
          (!_unref(isLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_9))
            : _createCommentVNode("", true),
          _hoisted_10
        ], 10, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["PReference_TableContainer", 
        _unref(isActive_KaniFlg)
          ? 'PReference_TableContainer_Show_KaniSearch'
          : 'PReference_TableContainer_Show_SyosaiSearch'
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["PReference_TableContainer", tableHeight()])
      }, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line1 sticky_column1 Text_Left th_sort",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable('syosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syosiCd")), 1),
                _createTextVNode("書誌コード ")
              ]),
              _createElementVNode("th", {
                class: "th_wide sticky_th sticky_th_line1 sticky_column2 Text_Left th_sort",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('category')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("category")), 1),
                _createTextVNode(" カテゴリ ")
              ]),
              _createElementVNode("th", {
                rowspan: "3",
                class: "th_small sticky_th sticky_th_line1 sticky_column3 th_sort",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('releaseDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("releaseDate")), 1),
                _createTextVNode("発売日 ")
              ]),
              _createElementVNode("th", {
                rowspan: "3",
                class: "th_narrow sticky_th sticky_th_line1 sticky_column4 th_sort",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('hontaiPrice')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("hontaiPrice")), 1),
                _createTextVNode("本体価格 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 sticky_column5 th_sort",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('items')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("items")), 1),
                _createTextVNode("良品 ")
              ]),
              _createElementVNode("th", {
                class: "th_small sticky_th sticky_th_line1 sticky_column6 th_sort",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('availableAmount')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("availableAmount")), 1),
                _createTextVNode("使用可能数 ")
              ]),
              _createElementVNode("th", {
                rowspan: "3",
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('inputSum'))),
                style: {"border-left":"none !important"}
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("inputSum")), 1),
                _createTextVNode("受注累計"),
                _hoisted_12,
                _createTextVNode("入力数 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('holdSum')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("holdSum")), 1),
                _createTextVNode("受注保留 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('thisWeek')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("thisWeek")), 1),
                _createTextVNode("当週 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('week1')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("week1")), 1),
                _createTextVNode("1週前 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('week2')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("week2")), 1),
                _createTextVNode("2週前 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('week3')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("week3")), 1),
                _createTextVNode("3週前 ")
              ]),
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("th", {
                class: "th_small sticky_th sticky_th_line1 th_sort",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable('juhanDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("juhanDate")), 1),
                _createTextVNode("重版予定日 ")
              ]),
              _createElementVNode("th", {
                class: "th_middle sticky_th sticky_th_line1 th_sort",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable('kaisoDate')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("kaisoDate")), 1),
                _createTextVNode("改装予定日 ")
              ]),
              _createElementVNode("th", {
                class: "th_narrow sticky_th sticky_th_line1 th_sort",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable('cover')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("cover")), 1),
                _createTextVNode("カバー ")
              ]),
              _createElementVNode("th", {
                class: "th_middle sticky_th sticky_th_line1 Text_Left th_sort",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (sortTable('zassiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("zassiCd")), 1),
                _createTextVNode("雑誌コード ")
              ]),
              _hoisted_16,
              _hoisted_17
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "th_middle sticky_th sticky_th_line2 sticky_column1 Text_Left th_sort",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (sortTable('syuppanSyosiCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("syuppanSyosiCd")), 1),
                _createTextVNode("出版社書誌CD ")
              ]),
              _createElementVNode("th", {
                rowspan: "2",
                class: "sticky_th sticky_th_line2 sticky_column2 Text_Left th_sort",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (sortTable('title')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("title")), 1),
                _createTextVNode("書名 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 sticky_column5 th_sort",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (sortTable('returnItems')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("returnItems")), 1),
                _createTextVNode("返品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 sticky_column6 th_sort",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (sortTable('averageSyuhin')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("averageSyuhin")), 1),
                _createTextVNode("平均集品数 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (sortTable('shinagireHoryuSuu')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("shinagireHoryuSuu")), 1),
                _createTextVNode("品切保留 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (sortTable('month1Sales')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month1Sales")), 1),
                _createTextVNode("1ヵ月前集品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (sortTable('month2Sales')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month2Sales")), 1),
                _createTextVNode("2ヵ月前集品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (sortTable('month3Sales')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month3Sales")), 1),
                _createTextVNode("3ヵ月前集品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (sortTable('month3SyuhinTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month3SyuhinTotal")), 1),
                _createTextVNode("3ヵ月集品計 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (sortTable('month6SyuhinTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month6SyuhinTotal")), 1),
                _createTextVNode("6ヵ月集品計 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (sortTable('month12SyuhinTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month12SyuhinTotal")), 1),
                _createTextVNode("12ヵ月"),
                _hoisted_18,
                _createTextVNode("集品計 ")
              ]),
              _hoisted_19,
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (sortTable('juhanQuantity')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("juhanQuantity")), 1),
                _createTextVNode("重版予定数 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[28] || (_cache[28] = ($event: any) => (sortTable('kaisoQuantity')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("kaisoQuantity")), 1),
                _createTextVNode("改装予定数 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line2 th_sort",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (sortTable('obi')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("obi")), 1),
                _createTextVNode("帯 ")
              ]),
              _hoisted_20
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 sticky_column1 Text_Left th_sort",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (sortTable('janCd')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("janCd")), 1),
                _createTextVNode("ISBN13桁 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 sticky_column5 th_sort",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (sortTable('zaikoTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("zaikoTotal")), 1),
                _createTextVNode("在庫合計 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 sticky_column6 th_sort",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (sortTable('torioki')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("torioki")), 1),
                _createTextVNode("取置 ")
              ]),
              _hoisted_21,
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[33] || (_cache[33] = ($event: any) => (sortTable('month1Return')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month1Return")), 1),
                _createTextVNode("1ヵ月前返品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[34] || (_cache[34] = ($event: any) => (sortTable('month2Return')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month2Return")), 1),
                _createTextVNode("2ヵ月前返品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (sortTable('month3Return')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month3Return")), 1),
                _createTextVNode("3ヵ月前返品 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[36] || (_cache[36] = ($event: any) => (sortTable('month3ReturnTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month3ReturnTotal")), 1),
                _createTextVNode("3ヵ月返品計 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[37] || (_cache[37] = ($event: any) => (sortTable('month6ReturnTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month6ReturnTotal")), 1),
                _createTextVNode("6ヵ月返品計 ")
              ]),
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[38] || (_cache[38] = ($event: any) => (sortTable('month12ReturnTotal')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("month12ReturnTotal")), 1),
                _createTextVNode("12ヵ月"),
                _hoisted_22,
                _createTextVNode("返品計 ")
              ]),
              _hoisted_23,
              _hoisted_24,
              _createElementVNode("th", {
                class: "sticky_th sticky_th_line3 th_sort",
                onClick: _cache[39] || (_cache[39] = ($event: any) => (sortTable('bookCase')))
              }, [
                _createElementVNode("span", null, _toDisplayString(showSortSymbol("bookCase")), 1),
                _createTextVNode("ケース ")
              ]),
              _hoisted_25
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_unref(search_result).length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(result.syosiCd), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(result.category), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(formatDate(result.releaseDate)), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(result.hontaiPrice?.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(result.items), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(result.availableAmount), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(result.inputSum), 1),
                      _createElementVNode("td", _hoisted_34, [
                        (Number(result.holdSum) > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (openOrderHold(result.syosiCd))
                            }, _toDisplayString(result.holdSum), 9, _hoisted_35))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(result.holdSum), 1))
                      ]),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(result.thisWeek), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(result.week1), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(result.week2), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(result.week3), 1),
                      _hoisted_41,
                      _hoisted_42,
                      _createElementVNode("td", _hoisted_43, _toDisplayString(result.zsName), 1),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(formatJuhanDate(result.juhanDate)), 1),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(formatDate(result.kaisoDate)), 1),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(result.cover), 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(result.zassiCd), 1),
                      _createElementVNode("td", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("p", _hoisted_51, _toDisplayString(result.itemRemarksDisplay), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(result.series), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_53, _toDisplayString(result.syuppanSyosiCd), 1),
                      _createElementVNode("td", _hoisted_54, _toDisplayString(result.title), 1),
                      _createElementVNode("td", _hoisted_55, _toDisplayString(result.returnItems), 1),
                      _createElementVNode("td", _hoisted_56, _toDisplayString(result.averageSyuhin), 1),
                      _createElementVNode("td", _hoisted_57, [
                        (Number(result.shinagireHoryuSuu) > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (openOrderOutOfStock(result.syosiCd))
                            }, _toDisplayString(result.shinagireHoryuSuu), 9, _hoisted_58))
                          : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(result.shinagireHoryuSuu), 1))
                      ]),
                      _createElementVNode("td", _hoisted_60, _toDisplayString(result.month1Sales), 1),
                      _createElementVNode("td", _hoisted_61, _toDisplayString(result.month2Sales), 1),
                      _createElementVNode("td", _hoisted_62, _toDisplayString(result.month3Sales), 1),
                      _createElementVNode("td", _hoisted_63, _toDisplayString(result.month3SyuhinTotal), 1),
                      _createElementVNode("td", _hoisted_64, _toDisplayString(result.month6SyuhinTotal), 1),
                      _createElementVNode("td", _hoisted_65, _toDisplayString(result.month12SyuhinTotal), 1),
                      _createElementVNode("td", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            (
                          result.vanStatusName &&
                          result.fromUpdateStatusDateDisplay !== null
                        )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(result.vanStatusName), 1))
                              : _createCommentVNode("", true),
                            (
                          result.vanStatusName !== null &&
                          result.toUpdateStatusDate === '9999-12-31'
                        )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_70, " (無期限) "))
                              : (result.fromUpdateStatusDateDisplay !== null)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_71, " (" + _toDisplayString(formatDate(result.fromUpdateStatusDate)) + "~" + _toDisplayString(formatDate(result.toUpdateStatusDate)) + ") ", 1))
                                : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_72, [
                        (formatJuhanDate(result.juhanDate) !== null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(result.juhanQuantity), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_74, "0"))
                      ]),
                      _createElementVNode("td", _hoisted_75, _toDisplayString(result.kaisoQuantity), 1),
                      _createElementVNode("td", _hoisted_76, _toDisplayString(result.obi), 1),
                      _createElementVNode("td", _hoisted_77, _toDisplayString(result.syubetu), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_78, _toDisplayString(result.janCd), 1),
                      _createElementVNode("td", _hoisted_79, _toDisplayString(result.zaikoTotal), 1),
                      _createElementVNode("td", _hoisted_80, [
                        (Number(result.torioki) > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (openToriokiDetail(result.janCd))
                            }, _toDisplayString(result.torioki), 9, _hoisted_81))
                          : (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(result.torioki), 1))
                      ]),
                      _hoisted_83,
                      _createElementVNode("td", _hoisted_84, _toDisplayString(result.month1Return), 1),
                      _createElementVNode("td", _hoisted_85, _toDisplayString(result.month2Return), 1),
                      _createElementVNode("td", _hoisted_86, _toDisplayString(result.month3Return), 1),
                      _createElementVNode("td", _hoisted_87, _toDisplayString(result.month3ReturnTotal), 1),
                      _createElementVNode("td", _hoisted_88, _toDisplayString(result.month6ReturnTotal), 1),
                      _createElementVNode("td", _hoisted_89, _toDisplayString(result.month12ReturnTotal), 1),
                      _createElementVNode("td", _hoisted_90, _toDisplayString(result.latestPrints), 1),
                      _createElementVNode("td", _hoisted_91, [
                        _createElementVNode("span", null, _toDisplayString(result.cutting), 1)
                      ]),
                      _createElementVNode("td", _hoisted_92, _toDisplayString(result.bookCase), 1),
                      _createElementVNode("td", _hoisted_93, _toDisplayString(result.author1) + _toDisplayString(result.author2) + _toDisplayString(result.author3), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        (!_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_94, " ※検索結果はありません "))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2))
}
}

})